import { createSelector } from 'reselect'
import getDynamicPaymentScheduleRequestInfo from './getDynamicPaymentScheduleRequestInfo'
import { getPaymentScheduleKey } from 'lib/payment/paymentScheduleUtils'

const getDynamicPaymentSchedule = createSelector(
  (state: App.State) => state.paymentSchedule,
  getDynamicPaymentScheduleRequestInfo,
  (paymentSchedule, dynamicPaymentScheduleRequestInfo): App.DynamicPaymentScheduleChargeData | undefined => {
    const key = getPaymentScheduleKey(dynamicPaymentScheduleRequestInfo)

    // Check if the key exists in charges before accessing it
    if (key && paymentSchedule.dynamicCharges && key in paymentSchedule.dynamicCharges) {
      return paymentSchedule.dynamicCharges[key]
    }

    return undefined
  },
)

export default getDynamicPaymentSchedule
